import { useState } from "react";
import { v4 as uuidv4 } from "uuid";

import { AddressesAPI } from "../../providers/AddressesAPI";
import { Input } from "../components/Input";

import styles from "../../styles/search-addresses.module.scss";
import { Message } from "../components/Message";

import { Button } from "@components";
import classNames from "classnames/bind";
import LazyInput from "shared/components/LazyInput";
import { If } from "shared/components/control-statements";
const cx = classNames.bind(styles);

export default function SearchAddresses({ onSelectAddress, isDrawer }) {
  const [sessionToken, setSessionToken] = useState("");
  const [searching, setSearching] = useState(false);
  const [addressString, setAddressString] = useState("");
  const [addressNumber, setAddressNumber] = useState("");
  const [missingAddressNumber, setMissingAddressNumber] = useState(false);
  const [lastScheduledSearch, setLastScheduledSearch] = useState();
  const [addressesOptions, setAddressesOptions] = useState([]);
  const [preSelectedAddress, setPreselectedAddress] = useState();
  const [addressNumberError, setAddressNumberError] = useState({
    message: "eerror",
    status: false,
  });
  const [selectedAddress, setSelectedAddress] = useState(null);

  const searchAddresses = async (term) => {
    const sessionToken = uuidv4();

    setAddressesOptions([]);

    if (term.length < 3) {
      setSearching(false);
      return;
    }

    setSearching(true);

    if (lastScheduledSearch) {
      clearInterval(lastScheduledSearch);
      setLastScheduledSearch();
    }

    const response = await AddressesAPI.searchAddresses(term, sessionToken);
    const addresses = response.getData({});
    setSearching(false);

    return addresses.length > 0
      ? addresses.map((address) => {
          return {
            id: address.id,
            label: null,
            name: address?.description,
            data: address,
          };
        })
      : [{ description: "Nenhum endereço encontrado." }];
  };

  const handleSelectAddress = async (address) => {
    const sessionToken = uuidv4();
    const response = await AddressesAPI.getAddressById(
      address.id,
      sessionToken
    );
    const result = response.getData({});
    setAddressString(result.formattedAddress);
    setAddressesOptions([]);

    if (!result.address?.number && !addressNumber) {
      setPreselectedAddress(address);
      onSelectAddress?.(null);
      setMissingAddressNumber(true);
    } else {
      result.address.number = result.address.number || addressNumber;
      onSelectAddress?.(result.address);
      setSelectedAddress(result.address);
      setAddressNumber(result.address.number);
      setMissingAddressNumber(false);
    }

    return result;
  };

  const searchByAddressNumber = async () => {
    const sessionToken = uuidv4();

    setAddressNumberError({
      message: "",
      status: false,
    });
    if (!addressNumber) {
      setAddressNumberError({
        message: "Por favor, informe o número!",
        status: true,
      });
      return;
    }
    const formatedAddress = `${preSelectedAddress.formattedText.primary} ${addressNumber} - ${preSelectedAddress.formattedText.secondary}`;
    const searchAddress = await AddressesAPI.searchAddresses(
      formatedAddress,
      sessionToken
    );
    const address = searchAddress.getData({})[0];
    await handleSelectAddress(address);
  };

  return (
    <>
      <div className={styles.searchContainer}>
        <div
          className={cx({
            searchForm: true,
            column: true,
          })}
        >
          <div className={styles.searchAddresses}>
            <div className="d-flex flex-column w-100">
              {(selectedAddress || missingAddressNumber) && (
                <Input
                  name="address"
                  design="three"
                  value={addressString || ""}
                  disabled
                />
              )}
              {!selectedAddress && !missingAddressNumber && (
                <LazyInput
                  placeholder="Buscar por..."
                  minTextLength={1}
                  design="search"
                  fillText={false}
                  onOption={(option) => {
                    handleSelectAddress(option?.data);
                  }}
                  findOptions={(term) => searchAddresses(term)}
                />
              )}
            </div>
            {missingAddressNumber && (
              <Input
                name="number"
                design="two"
                className="ml-15"
                label="Número"
                value={addressNumber || ""}
                onChange={(e) => setAddressNumber(e.target.value)}
              />
            )}
          </div>
          {missingAddressNumber && (
            <Button
              design="primary"
              onClick={searchByAddressNumber}
              disabled={!addressNumber}
            >
              Confirmar
            </Button>
          )}
        </div>

        {addressNumberError.status && (
          <Message className="mt-15" text={addressNumberError.message} />
        )}
      </div>
    </>
  );
}
